<template>
  <section class="bg-light py-4">
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-lg-2 mb-3 mb-md-0">
          <a href="/dashboard" class="btn btn-link"><span
              class="far fa-long-arrow-left pr-2"></span>Terug</a>
        </div>
        <div class="col-md-9 col-lg-8">
          <div class="card card-blue mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h1 class="h2">Opzeggen</h1>
            </div>
            <div class="card-body">
              <p>Via onderstaand formulier is het mogelijk om je account te beëindigen. Je verzoek wordt binnen enkele werkdagen verwerkt, waarna je per mail een bevestiging ontvangt van je opzegging.</p>
              <form @submit.prevent="submit" method="post">
                <div class="custom-control custom-checkbox mb-3" :class="{ 'has-invalid': $v.checkboxEnd.$error }">
                  <input type="checkbox" id="checkbox-visit-doctor" class="custom-control-input"
                         v-model="checkboxEnd" @focus="$v.checkboxEnd.$reset">
                  <label for="checkbox-visit-doctor" class="custom-control-label">Ik wil stoppen met Socialtens.</label>
                </div>
                <div class="form-group" :class="{ 'has-invalid': $v.explanation.$error }">
                  <label for="text-profession">Toelichting</label>
                  <textarea name="message" id="text-profession" rows="4" class="form-control"
                            v-model.trim.lazy="$v.explanation.$model"
                            @focus="$v.explanation.$reset"></textarea>
                </div>
                <button type="button" class="btn btn-primary" @click="submit()">Ik wil opzeggen</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import mustBeTrue from '../js/validators/mustBeTrue';
import {required} from 'vuelidate/lib/validators';

export default {
    props: {
        route: String,
    },
    data() {
        return {
            checkboxEnd: false,
            explanation: '',
            processing: false,
        };
    },
    validations() {
        return {
            checkboxEnd: {
                mustBeTrue,
            },
            explanation: {
                required,
            }
        }
    },
    methods: {
        submit() {
            this.$v.$touch();

            if (this.processing) {
                return false;
            }

            if (!confirm('Let op: je kunt je niet binnen 24 maanden na opzegging opnieuw inschrijven.')) {
                return false;
            }

            this.processing = true;

            let that = this;

            this.axios.post(this.route, {
                allowEnd: this.checkboxEnd,
                explanation: this.explanation,
            })
                .then(() => {
                    that.sick = true;

                    that.$notify({
                        group: 'base',
                        text: 'Je verzoek tot opzegging is ontvangen.',
                        type: 'alert-info',
                    });

                    // return to dashboard
                    window.location = '/dashboard';
                })
                .catch(error => {
                    let msg = 'Er is een fout opgetreden.';
                    if (error.response.data.errors.allowEnd) {
                        msg = 'Je dient akkoord te gaan met alle verplichte velden.';
                    }

                    that.$notify({
                        group: 'base',
                        text: msg,
                        type: 'alert-danger',
                    });
                });

            this.processing = false;
        },
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/components/EndSubscription.vue